<template>
  <div ref="notificationInfo">
      <div class="row align-items-center justify-content-start w-100">
        <div class="d-flex align-items-center col-md-12">
          <feather-icon
            class="icon-hover mr-2"
            icon="ChevronLeftIcon"
            size="24"
            @click="returnNotifications()"
          />
          <h5 class="mb-0" v-if="form.title"><strong>{{ form.title }}</strong></h5>
          <b-form-checkbox
              switch
              class="checkbox-switch switch-notification ml-1"
              v-model="form.activated">
              <span class="personalize-status">{{ !!form.activated ? 'Activo' : 'Inactivo' }}</span>
          </b-form-checkbox>
        </div> 
        <div class="padding-form-notification col-md-12">
          <form-render :form.sync="form" :fields="fields" @send="updateOrCreate" ref="formRenderNewNotification" :key="keyFormRender">
            <template #companies>
              <div class="row">
                  <div class="col-md-12 companies">
                  <label title="Empresa" class="label-form"><span>Empresa</span></label>
                      <v-select
                      v-model="form.companies"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      placeholder="Seleccione empresa"
                      label="text"
                      :options="formattedOrganization"
                      :disabled="loading.companies"
                      @option:deselecting="onDeselect"
                      @input="changeCompany('prueba', form.companies)"
                      :multiple="true"
                      />
                  </div>
              </div>
            </template>
            <template #image_btn>
              <div class="row">
                  <div class="col-md-12 image-btn d-flex align-items-end">
                    <b-button variant="primary" @click="openModalUploadImage">
                      <feather-icon
                        icon="ImageIcon"
                        size="16"
                        class="mr-50"
                      /> 
                      <span>Seleccionar Imagen</span>
                    </b-button>
                  </div>
              </div>
            </template>
            <template #line>
              <hr>
            </template>
            <template #date>
              <div class="row">
                  <div class="col-md-12">
                    <label title="Fecha de vigencia" class="label-form">
                      <span>Fecha de vigencia</span>
                      <span class="text-danger"> *</span>
                    </label>
                    <field-datepicker
                      :value.sync="form.date_range"
                      :range="true"
                      :showCalendarIcon="true"
                      :requiredDateRange="error_date"
                      :change="changeDate"
                    />
                    <div :class="error_date ? 'invalid-feedback d-block' : 'invalid-feedback'">
                      Este campo es
                      requerido </div>
                  </div>
              </div>
            </template>
          </form-render>
          <div class="d-flex justify-content-end mt-2">
            <b-button @click="validateForm" :disabled="loading.all" variant="warning">
              <span>{{acceptText}}</span>
            </b-button>
          </div>
        </div>
    </div>
    <modal-upload-image ref="modalUploadImage" @setImageForm="setImageForm"></modal-upload-image>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import BaseServices from '@/store/services/index'
import ModalUploadImage from '../modals/ModalUploadImage.vue'
export default {
  components: {vSelect, ModalUploadImage},
  props: ['data', 'syncNotifications'],
  data () {
    return {
      tabIndex: 0,
      form: {},
      content: '',
      acceptText: 'Crear',
      title: '',
      company: {},
      today : new Date(),
      fields: [],
      loading: {
        all: false,
        companies: false,
        shipper_id: false
      },
      optionsCountries: [],
      optionsType: [
        { id: 'companies', text: 'Empresas'},
        { id: 'onlyCompanyId_companies', text: 'Ids de seller'},
        { id: 'onlyCompanyId_marketplaces', text: 'Ids de marketplaces'},
        { id: 'onlyCompanyId_sellersByMarketplaces', text: 'Sellers por ids de marketplaces'}
      ],
      optionsExcludeType: [
        { id: 'onlyCompanyId_companies', text: 'Ids de empresas'},
        { id: 'onlyCompanyId_sellersByMarketplaces', text: 'Sellers por ids de marketplaces'},
        { id: 'onlyCompanyId_allSellersMarketplaces', text: 'Todos los sellers de marketplaces'}
      ],
      optionsCategory: [
        {id: 'category_update', text: 'Actualización Condiciones', color: 'info'},
        {id: 'category_alert', text: 'Alerta Operacional', color: 'warning'},
        {id: 'category_new', text: 'Nuevo', color: 'success'}
      ],
      optionsCommunication: [
        {id: 'standard', text: 'Estándar'},
        {id: 'personalized', text: 'Personalizado'}
      ],
      optionsAccount: [
        {id: 'distribution', text: 'Distribución', name: 'distribucion'},
        {id: 'gateway', text: 'Pasarela', name: 'pasarela' }
      ],
      optionsBilling: [{id: false, text: 'Notificar sólo a usuarios facturación directa'}],
      optionsPopUp: [{id: false, text:'Habilitar notificación en la pantalla principal'}],
      keyFormRender: 0,
      baseService: new BaseServices(this),
      formattedShipper: [],
      carrierssByShipOrg: [],
      deleteShipperFromArray: {
        click: false
      },
      indexShipper: null,
      CONDITIONS: Object.freeze({
        CREATE: 'create',
        EDIT: 'edit'
      }),
      error_date: false
    }
  },
  computed: {
    ...mapGetters({
      mySession: 'getSession',
      organizations: 'getOrganizationsGlobal',
      carriers: 'getCarriersNotifications',
      countries: 'getCountries'
    })
  },
  watch: {
    data () { 
      this.setNotification()
    },
    mySession () {
      if (this.mySession.id) this.setInitialData()
    },
    organizations () {
      this.formattedOrganization = this.organizations.map(el => {
        if (el.organization_type.id === 1) {
          return {...el, text: `${el.name} (M)`}
        } else {
          return {...el, text: el.name}
        }
      })
      this.setSelectOptions('companies', { options: this.formattedOrganization })
      this.loading.all = false
    },
    carriers () {
      this.setSelectOptions('carriers', { options: this.carriers })
      this.loading.all = false
    },
    countries () {
      this.setCountries()
    }
  },
  mounted () {
    this.getAllInitialData()
  },
  methods: {
    getAllInitialData () {
      if (this.mySession.id) this.setInitialData()
    },
    setInitialData () {
      this.setCountries()
      this.setFields()
      if (this.organizations && !!this.organizations.length) {
        this.formattedOrganization = this.organizations.map(el => {
          if (el.organization_type.id === 1) {
            return {...el, text: `${el.name} (M)`}
          } else {
            return {...el, text: el.name}
          }
        })
        this.setSelectOptions('companies', { options: this.formattedOrganization })
        this.loading.all = false
      }
      if (this.carriers && !!this.carriers.length) {
        this.setSelectOptions('carriers', { options: this.carriers })
        this.loading.all = false
      }
      this.setNotification()
    },
    setCountries () {
      if (this.countries && !!this.countries.length) {
        const countriesFormatter = this.countries.map(country => {
          return {
            id: country.id, 
            text: country.text, 
            code: country.code 
          }
        })
        countriesFormatter.unshift({ id: '*', text: 'Todos', code: 'all' })
        this.optionsCountries = countriesFormatter
      }
      
    },
    setNotification () {
      this.form = {
        ...this.data,
        activated: !this.data.inactive,
        enabling: this.data.enabling ? new Date(this.data.enabling) : null,
        expiration: this.data.expiration ? new Date(this.data.expiration) : null,
        image_name: this.data.image_personalize ? this.data.image_personalize.name : null,
        image: this.data.image_personalize || null
      }
      this.acceptText = !!this.data.id ? 'Guardar cambios' : 'Crear'
      this.form.date_range = {
        start: this.form.enabling,
        end: this.form.expiration
      }
      this.fields = this.fields.filter(el => !['companies', 'onlyCompanyId', 'exclude_onlyCompanyId'].includes(el.name))
      this.indexShipper.containerClass = 'hidden' 
      this.formattedShipper = []
      this.setSelectOptions('carriers', { options: this.carriers })
      if (!!this.data.id) {
        this.form.enable_pop_up = this.data.enable_pop_up ?? true
        this.form.type_communication = this.data.type_communication || this.optionsCommunication[1]
        this.changeCommunication('type_communication', this.form.type_communication)
        this.changeType('type', this.form.type)
        this.changeExcludeType('exclude_type', this.form.exclude_type)
        if (this.data?.companies.length > 0) this.changeCompany('companies', this.form.companies)
      } 
      else {
        this.form.activated = true
        this.form.type_communication = this.optionsCommunication[0]
      }
    },
    setFields () {
      this.fields = [
        { fieldType: 'FieldSelect', label: 'País', name: 'country', containerClass: 'col-md-3 container-info', validation: 'required', options: this.optionsCountries, change: this.changeCountry, disabled: false},
        { fieldType: 'FieldSelect', label: 'Categoría', name: 'category', containerClass: 'col-md-3 container-info', clearable: true,  validation: '', options: this.optionsCategory},
        { name: 'date', useSlot: true, containerClass: 'col-md-3 container-info'},
        { fieldType: 'FieldSelect', label: 'Tipo de comunicado', name: 'type_communication', containerClass: 'col-md-3 container-info', clearable: false,  validation: '', options: this.optionsCommunication, change: this.changeCommunication},
        { fieldType: 'FieldSelect', label: 'Tipo de empresa', name: 'type', containerClass: 'col-md-3 container-info', clearable: true,  validation: '', options: this.optionsType, change: this.changeType, tooltip: { text: 'Deje en blanco para aplicar a todos.' }},
        { fieldType: 'FieldSelect', name: 'shipper_id', label: 'Seller', useLabel: true, placeholder: 'Seleccione Seller', clearable: true, useSkeleton: false, containerClass: 'hidden', multiple: true, notCloseOnSelect: true},
        { fieldType: 'FieldSelect', label: 'Tipo de contrato', name: 'account_type', containerClass: 'col-md-3 container-info', clearable: true,  validation: '', options: this.optionsAccount, tooltip: { text: 'Deje en blanco para aplicar a todos.' }},
        { fieldType: 'FieldSelect', label: 'Ids a excluir', name: 'exclude_type', containerClass: 'col-md-6 container-info', clearable: true,  validation: '', options: this.optionsExcludeType, change: this.changeExcludeType},
        { fieldType: 'FieldSelect', label: 'Limitar couriers', useLabel: true, name: 'carriers', containerClass: 'col-md-6 container-info', multiple: true, useSkeleton: false, tooltip: { text: 'Deje en blanco para aplicar a todos.' }},
        { fieldType: 'FieldCheckbox', name: 'direct_billing', label: '', containerClass: 'col-md-6 d-flex align-items-center', align: 'h', options: this.optionsBilling, validation: ''},
        { name: 'line', useSlot: true, containerClass: 'container-info col-12' },
        { fieldType: 'FieldInput', label: 'Título de apoyo', name: 'title_support', containerClass: 'col-md-6 container-info', validation: 'required'},
        { fieldType: 'FieldInput', label: 'Imagen/Ilustración', name: 'image_name', containerClass: 'col-md-3 container-info', placeholder:'No hay imagen seleccionada', validation: 'required', disabled: true},
        { name: 'image_btn', useSlot: true, containerClass: 'col-md-3 container-info justify-content-end'},
        { fieldType: 'FieldInput', label: 'Título', name: 'title', containerClass: 'col-md-6 container-info', validation: 'required'},
        { fieldType: 'FieldCheckbox', name: 'enable_pop_up', label: '', containerClass: 'col-md-6 d-flex align-items-center', align: 'h', options: this.optionsPopUp, validation: ''},
        { fieldType: 'FieldRTE', label: 'Contenido', name: 'content', containerClass: 'col-md-12 container-info', validation: 'required'}
      ]
      this.indexShipper = this.fields.find(item => item.name === 'shipper_id')
      this.indexCarrier = this.fields.find(item => item.name === 'carriers')
      this.indexCountry = this.fields.find(item => item.name === 'country')
    },
    async sync() {
      await this.syncNotifications()
    },
    deleteDiacritics(text) {
      return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    },
    setPayload (myForm, type) {
      const dateSplit = this.form.date_range?.end ? this.$options.filters.moment(this.form.date_range.end, 'DD-MM-YYYY').split('-') : null
      const enablingDate = this.form.date_range?.start ? this.$options.filters.moment(this.form.date_range.start, 'DD-MM-YYYY').split('-') : null
      const formatterTitle = this.deleteDiacritics(myForm.title)
      const splitTitle = formatterTitle.toLowerCase().split(' ')
      this.carriersArray = []
      this.companiesArray = []
      this.shippersArray = []
      this.carriersCode = []
      if (myForm.carriers?.length > 0) {
        this.carriersArray = this.keywordsByType(myForm.carriers)
        this.carriersCode =  myForm.carriers.map(item => item.code)
      }
      if (myForm.companies?.length > 0) this.companiesArray = this.keywordsByType(myForm.companies)
      if (myForm.shipper_id?.length > 0) this.shippersArray = this.keywordsByType(myForm.shipper_id)
      const splitKeywords = splitTitle.concat(this.carriersArray, this.companiesArray, this.shippersArray)
      const payload = {
        title: myForm.title,
        title_support: myForm.title_support || null,
        content:myForm.content,
        country: myForm.country,
        carriers: myForm.carriers || [],
        carriersCode: this.carriersCode,
        type: myForm.type || null,
        category: myForm.category || null,
        companies: myForm.companies || [],
        shipper_id: myForm.shipper_id || [],
        onlyCompanyId: myForm.onlyCompanyId || '',
        exclude_type: myForm.exclude_type || null,
        exclude_onlyCompanyId: myForm.exclude_onlyCompanyId || '',
        inactive: !this.form.activated,
        expiration: dateSplit ? parseInt(this.$options.filters.moment(new Date(dateSplit[2], dateSplit[1] - 1, dateSplit[0], 23, 59, 59), 'x')) : 9999999999999,
        enabling: enablingDate ? parseInt(this.$options.filters.moment(new Date(enablingDate[2], enablingDate[1] - 1, enablingDate[0], 0, 0, 1), 'x')) : 0,
        keywordsArray: splitKeywords,
        account_type: myForm.account_type || null,
        direct_billing: myForm.direct_billing || false,
        type_communication: myForm.type_communication,
        image_personalize: this.form.image || null,
        enable_pop_up: this.form.enable_pop_up || false

      }
      if (type === this.CONDITIONS.CREATE) {
        payload.created = new Date().getTime()
      }
      else {
        payload._id = this.form.id
        payload.updated = new Date().getTime()
      }
      return payload
    },
    updateOrCreate (myForm) {
      if (this.error_date) {
        return
      }
      this.loading.all = true
      if (!this.form.id) {
        this.currentForm = this.setPayload(myForm, this.CONDITIONS.CREATE)
        this.$root.$data.notificationsCollection.add(this.currentForm)
          .then(resp => {
            this.$root.$data.currentNotificationsCollection.doc('all').update({
              data: this.$root.$data.newA(resp.id)
            })
              .then(async () => {
                this.acceptText = 'Guardar cambios'
                this.form.id = resp.id
                await this.$root.$data.db.collection('lastChangeNotifications').doc('time-last-change-notifications').set({ time: Date.now() })
                this.$emit('savedNotification', resp.id)
              })
              .catch(err => {
                this.sync()
                this.loading.all = false
              })
          })
          .catch(err => {
            this.$alert(this.$t('msg-problema-guardar', {code: err}))
            this.loading.all = false
            console.error(err)
          })
      } else {
        this.currentForm = this.setPayload(myForm, this.CONDITIONS.EDIT)
        this.$root.$data.notificationsCollection.doc(this.form.id).update(this.currentForm)
          .then(async () => {
            this.loading.all = false
            this.$emit('savedNotification', null)
            await this.$root.$data.db.collection('lastChangeNotifications').doc('time-last-change-notifications').set({ time: Date.now() })
            this.$newSuccess('Comunicado editado con éxito!', 'Ahora puedes verlo reflejado en la plataforma.')
          })
          .catch(err => {
            this.$alert(this.$t('msg-problema-guardar', {code: err}))
            this.loading.all = false
            console.error(err)
          })
      } 
    },
    changeDate (name, value) {
      this.error_date = !value?.start && !value?.end
    },
    validateForm () {
      this.error_date = !this.form.date_range?.start && !this.form.date_range?.end
      this.$refs.formRenderNewNotification.checkForm()
    },
    changeType (name, value) {
      this.fields = this.fields.filter(el => !['companies', 'onlyCompanyId'].includes(el.name))
      if (value && value.id) {
        const index = this.fields.findIndex(el => el.name === 'type')
        const myFields = {
          companies: { name: 'companies', useSlot: true, containerClass: 'col-md-12 container-info'}, 
          onlyCompanyId_companies: { fieldType: 'FieldTextarea', label: 'Ids de empresas numéricas separadas por coma (,) y sin espacios', name: 'onlyCompanyId', containerClass: 'col-md-12 container-info'},
          onlyCompanyId_marketplaces: { fieldType: 'FieldTextarea', label: 'Ids de marketplaces numéricas separadas por coma (,) y sin espacios', name: 'onlyCompanyId', containerClass: 'col-md-12 container-info'},
          onlyCompanyId_sellersByMarketplaces: { fieldType: 'FieldTextarea', label: 'Ids de marketplaces numéricas separadas por coma (,) y sin espacios', name: 'onlyCompanyId', containerClass: 'col-md-12 container-info'}
        }
        this.fields.splice(index + 1, 0, myFields[value.id])
      } 
      if (!value || value.id !== 'companies') {
        this.indexShipper.containerClass = 'hidden' 
        this.form.companies = null
        this.form.shipper_id = null
        this.formattedShipper = []
      }
      this.keyFormRender++
    },
    changeExcludeType (name, value) {
      this.fields = this.fields.filter(el => !['exclude_onlyCompanyId'].includes(el.name))
      if (value && value.id) {
        const index = this.fields.findIndex(el => el.name === 'exclude_type')
        const myFields = {
          onlyCompanyId_companies: { fieldType: 'FieldTextarea', label: 'Ids de empresas numéricas separadas por coma (,) y sin espacios', name: 'exclude_onlyCompanyId', containerClass: 'col-md-12 container-info'},
          onlyCompanyId_sellersByMarketplaces: { fieldType: 'FieldTextarea', label: 'Ids de marketplaces numéricas separadas por coma (,) y sin espacios', name: 'exclude_onlyCompanyId', containerClass: 'col-md-12 container-info'}
        }
        if (myFields[value.id]) {
          this.fields.splice(index + 1, 0, myFields[value.id])
        }
      }
      this.keyFormRender++
    },
    setSelectOptions (name, { options }) {
      const index = this.fields.findIndex(el => el.name === name)
      if (index !== -1) {
        this.fields[index].options = options
        this.keyFormRender++
      }
    },
    async changeCompany (name, value) {
      const marketplace = value.filter(item => item.organization_type.id === 1)
      if (marketplace.length === 0) this.form.shipper_id = null
      this.indexShipper.containerClass = marketplace.length > 0 ? 'col-md-12 container-info' : 'hidden'     
      const lastMKPAdded = marketplace[marketplace.length - 1]
      const lastCompanyAdded = value[value.length - 1]
      if (!this.deleteShipperFromArray.click) {
        if (value.length > 0) { 
          this.loading.companies = true
          this.indexCarrier.useSkeleton = true
          if (lastCompanyAdded.organization_type.id !== 2) {          
            await this.getShippers(lastMKPAdded)
          } 
          await this.getCarriersByType(value)
          this.loading.companies = false
          this.indexShipper.useSkeleton = false
        } else {
          this.formattedShipper = []
        }
      } 
      else {
        const deleteShippers = this.formattedShipper.filter(item => item.organization_id !== this.deleteShipperFromArray.info.id)
        this.formattedShipper = deleteShippers
        this.setSelectOptions('shipper_id', { options: this.formattedShipper })        
        if (value.length === 0) {
          this.form.shipper_id = null 
          this.setSelectOptions('carriers', { options: this.carriers })
        }
        else {
          this.indexCarrier.useSkeleton = true
          await this.getCarriersByType(value)
        }
        this.deleteShipperFromArray.click = false 
        this.deleteShipperFromArray.info = null

      }
      this.keyFormRender++
      
    },
    changeCommunication (name, value) {
      const fieldNames = ['title_support', 'image_name', 'image_btn']
      fieldNames.forEach(fieldName => {
        const field = this.fields.find(item => item.name === fieldName)
        if (field) {
          let containerClass = 'hide'
          let validation = ''
          if (value.id === 'standard') {
            const columnSize = field.name === 'title_support' ? 6 : 3
            const justifyClass = field.name === 'image_btn' ? 'justify-content-end' : ''
            containerClass = `col-md-${columnSize} container-info ${justifyClass}`
            validation = field.name !== 'image_btn' ? 'required' : ''
          }
          field.containerClass = containerClass
          field.validation = validation
        }
      })
      this.keyFormRender++
    },
    onDeselect (data) {
      if (!!data) {
        this.deleteShipperFromArray.click = true 
        this.deleteShipperFromArray.info = data
      }
    },
    changeCountry (name, value) {
      const originalCarriers = this.setSelectOptions('carriers', { options: this.carriers })
      this.form.carriers = null
      if (value !== null) {
        if (value.id !== '*') {
          const filterCarrierByCountry = this.carriers.filter(item => {
            return item.country_id === value.id
          })
          this.setSelectOptions('carriers', { options: filterCarrierByCountry })
        } else {
          return originalCarriers
        }
      } else {
        return originalCarriers
      } 
    },
    getShippers (value) {
      const queryParams = {}
      const params = {
        organization_id: value.id
      }
      this.indexShipper.useSkeleton = true
      return this.baseService.callService('getShipperFormattedNotifications', queryParams, params)
        .then(resp => {
          const old = this.formattedShipper
          const news = resp.data.map(el => ({...el, text: `${el.name} - ${value.name}`, organization_id: value.id}))
          const concatenated = old.concat(news)
          this.formattedShipper = concatenated
          this.setSelectOptions('shipper_id', { options: this.formattedShipper })
          this.keyFormRender++
        })
        .catch(err => {
          return err
        })
    },
    getCarriersByType (value) {
      const lastCompanyAdded = value[value.length - 1]
      const params = {
        company_id: lastCompanyAdded.id
      }
      const queryParams = {}
      return this.baseService.callService('getActiveCarrier', queryParams, params)
        .then(resp => {
          const response =  resp.data.carriers.map(carrier => ({...carrier, text: carrier.name}))
          lastCompanyAdded.carriers = response
          let carriers = []
          this.indexCarrier.useSkeleton = false
          carriers = this.carriers.filter(el => value.findIndex(company => company.carriers.map(carrier => carrier.code).includes(el.code)) !== -1).map(el => ({...el, text: el.name}))    
          this.setSelectOptions('carriers', { options: carriers })
        })
        .catch(err => {
          return err
        })
    },
    async changeShipper (name, value) {
      this.loading.shipper_id = true
      if (value.length > 0) { 
        this.loading.companies = true
        this.indexCarrier.useSkeleton = true
        await this.getCarriersByType(value)
        this.loading.companies = false
        this.loading.shipper_id = false
      }     
      this.keyFormRender++
    },
    keywordsByType (data) {
      const names = data.map(item => {
        const formatterItem = this.deleteDiacritics(item.name)
        return formatterItem.toLowerCase().split(' ')
      })
      const flatNames = names.flat()
      return flatNames
    },
    returnNotifications () {
      this.$emit('returnNotifications', {list: true, notification: false})
    },
    openModalUploadImage () {
      this.$bvModal.show('modalUploadImage')
    },
    setImageForm (image, type) {
      this.form.image = image    
      this.form.image_name = image.name
      this.keyFormRender++
    } 
  }
}
</script>
<style lang="scss">
.switch-notification
  .custom-control-label {
  margin-bottom: 0 !important;
}
.switch-notification 
  .custom-control-input:checked ~ .custom-control-label::before,
  .custom-control-input:active:not(:disabled) ~ .custom-control-label::before {
  border-color: #1E8E3E;
  background-color: #1E8E3E;
}
.switch-notification
  .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before,
  .custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: #1f9d57a8 !important;
}
.padding-form-notification{
  padding: 2rem 5rem;
}
.rule-dialog {
  .vs-dialog {
    height: 1900px;
  }
}
.companies .vs__selected, .shipper_id .vs__selected {
    background-color: #044389 !important;
}
.companies .vs__dropdown-menu, .shipper_id .vs__dropdown-menu{
    top: 2.5rem !important;
}
.v-select:not(.select-multiple) > .vs__dropdown-toggle > .vs__selected-options > .vs__selected {
    width: auto !important;
}
.image-btn span {
  font-size: 14px;
}
.hide {
  display: none;
}
.icon-hover:hover {
  cursor: pointer;
}
</style>